import { useState, useEffect, useCallback } from 'react';
import Footer from '../components/Footer';
import { supabase } from '../config/supabase';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'

const categories = [
  {
    id: 'lifestyle',
    title: 'Lifestyle',
    description: 'ภาพที่แสดงถึงชีวิตประจำวัน เช่น การทำงาน การเล่น',
    thumbnail: '/images/categories/lifestyle-1done.jpeg'
  },
  {
    id: 'business',
    title: 'Business & Office',
    description: 'ภาพพนักงานออฟฟิศ การประชุม การทำงานเป็นทีม',
    thumbnail: '/images/categories/business-1done.jpeg'
  },
  {
    id: 'technology',
    title: 'Technology',
    description: 'ภาพคอมพิวเตอร์ สมาร์ทโฟน หุ่นยนต์ อินเทอร์เน็ต',
    thumbnail: '/images/categories/technology-1done.jpeg'
  },
  {
    id: 'nature',
    title: 'Nature & Landscape',
    description: 'ภูเขา ทะเล ป่าไม้ สัตว์ป่า',
    thumbnail: '/images/categories/nature-1done.jpeg'
  },
  {
    id: 'people',
    title: 'People & Emotions',
    description: 'การแสดงอารมณ์ต่าง ๆ เช่น ความสุข ความเศร้า',
    thumbnail: '/images/categories/people-1done.jpeg'
  },
  {
    id: 'health',
    title: 'Health & Wellness',
    description: 'การออกกำลังกาย โยคะ การดูแลสุขภาพ',
    thumbnail: '/images/categories/health-1done.jpeg'
  },
  {
    id: 'food',
    title: 'Food & Beverage',
    description: 'ภาพอาหารจานเดี่ยว อาหารเพื่อสุขภาพ',
    thumbnail: '/images/categories/food-1done.jpeg'
  },
  {
    id: 'travel',
    title: 'Travel & Adventure',
    description: 'สถานที่ท่องเที่ยว สถานที่สำคัญ',
    thumbnail: '/images/categories/travel-1done.jpeg'
  },
  {
    id: 'education',
    title: 'Education',
    description: 'นักเรียน หนังสือ การเรียนการสอน',
    thumbnail: '/images/categories/education-1done.jpeg'
  },
  {
    id: 'medical',
    title: 'Medical & Healthcare',
    description: 'แพทย์ พยาบาล โรงพยาบาล',
    thumbnail: '/images/categories/medical-1done.jpeg'
  },
  {
    id: 'architecture',
    title: 'Architecture & Interiors',
    description: 'อาคาร สำนักงาน บ้าน',
    thumbnail: '/images/categories/architecture-1done.jpeg'
  },
  {
    id: 'abstract',
    title: 'Abstract',
    description: 'พื้นผิว รูปแบบกราฟิก สีสันสดใส',
    thumbnail: '/images/categories/abstract-1done.jpeg'
  },
  {
    id: 'sports',
    title: 'Sports & Fitness',
    description: 'ฟุตบอล บาสเกตบอล วิ่ง',
    thumbnail: '/images/categories/sports-1done.jpeg'
  },
  {
    id: 'fashion',
    title: 'Fashion & Beauty',
    description: 'เสื้อผ้า นางแบบ การแต่งหน้า',
    thumbnail: '/images/categories/fashion-1done.jpeg'
  },
  {
    id: 'seasonal',
    title: 'Seasonal & Holidays',
    description: 'คริสต์มาส ฮาโลวีน วันวาเลนไทน์',
    thumbnail: '/images/categories/seasonal-1done.jpeg'
  },
  {
    id: 'animals',
    title: 'Animals & Wildlife',
    description: 'สุนัข แมว สัตว์ในป่า',
    thumbnail: '/images/categories/animals-1done.jpeg'
  },
  {
    id: 'industrial',
    title: 'Industrial & Manufacturing',
    description: 'โรงงาน เครื่องจักร การก่อสร้าง',
    thumbnail: '/images/categories/industrial-1done.jpeg'
  },
  {
    id: 'transportation',
    title: 'Transportation',
    description: 'รถยนต์ เครื่องบิน รถไฟ',
    thumbnail: '/images/categories/transportation-1done.jpeg'
  },
  {
    id: 'urban',
    title: 'Urban & Cityscapes',
    description: 'ตึกระฟ้า ถนนในเมือง',
    thumbnail: '/images/categories/urban-1done.jpeg'
  },
  {
    id: 'sustainability',
    title: 'Green & Sustainability',
    description: 'พลังงานสะอาด การปลูกต้นไม้',
    thumbnail: '/images/categories/sustainability-1done.jpeg'
  }
];

const Popular = () => {
  const [categoriesWithCount, setCategoriesWithCount] = useState(categories);
  const [selectedKeywords, setSelectedKeywords] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [downloadsRemaining, setDownloadsRemaining] = useState(null);
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [userSubscription, setUserSubscription] = useState(null);
  
  // ฟังก์ชันเช็คการดาวน์โหลด
  const checkDownloadLimit = useCallback(async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setDownloadsRemaining(0);
        setIsDownloadDisabled(true);
        setUserSubscription('free');
        return;
      }

      // เปลี่ยนจากการเช็ค subscriptions เป็นเช็ค profiles
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('membership')
        .eq('id', user.id)
        .single();

      if (profileError || !profileData) {
        setDownloadsRemaining(0);
        setIsDownloadDisabled(true);
        setUserSubscription('free');
        return;
      }

      // ถ้าเป็น free membership
      if (!profileData.membership || profileData.membership === 'free') {
        setDownloadsRemaining(0);
        setIsDownloadDisabled(true);
        setUserSubscription('free');
        return;
      }

      setUserSubscription(profileData.membership);
      
      // เช็คจำนวนดาวน์โหลด
      const currentDate = new Date().toISOString().split('T')[0];
      const { data: downloadData, error: downloadError } = await supabase
        .from('downloads')
        .select('*')
        .eq('user_id', user.id)
        .eq('download_date', currentDate)
        .maybeSingle();

      if (downloadError) {
        console.error('Error fetching downloads:', downloadError);
        setDownloadsRemaining(0);
        setIsDownloadDisabled(true);
        return;
      }

      const currentCount = downloadData?.count || 0;
      const remaining = 10 - currentCount;
      
      setDownloadsRemaining(remaining);
      setIsDownloadDisabled(remaining <= 0);
      
    } catch (error) {
      console.error('Error:', error);
      setDownloadsRemaining(0);
      setIsDownloadDisabled(true);
      setUserSubscription('free');
    }
  }, []);

  // useEffect สำหรับโหลดข้อมูลครั้งแรก
  useEffect(() => {
    checkDownloadLimit();
    const interval = setInterval(checkDownloadLimit, 30000);
    return () => clearInterval(interval);
  }, [checkDownloadLimit]);

  // ฟังก์ชันจัดการการคลิกที่การ์ด
  const handleCardClick = useCallback((category) => {
    if (!isDownloadDisabled) {
      setSelectedCategory(category);
      setIsModalOpen(true);
    }
  }, [isDownloadDisabled]);

  // อัพเดทฟังก์ชันดาวน์โหลด
  const downloadKeywordsFile = async (keywords, category) => {
    try {
      // ตรวจสอบจำนวนดาว���์โหลด
      const canDownload = await checkDownloadLimit();
      
      if (!canDownload) {
        alert('คุณได้ใช้จำนวนดาวน์โหลดครบ 10 ครั้งต่อวันแล้ว');
        return;
      }

      // บันทึกประวัติการดาวน์โหลด
      const today = new Date().toISOString().split('T')[0];
      const { error: downloadError } = await supabase
        .from('downloads')
        .upsert([
          {
            user_id: supabase.auth.user()?.id,
            download_date: today,
            count: (10 - downloadsRemaining) + 1,
            category_id: category.id,
            expires_at: new Date(Date.now() + 24*60*60*1000).toISOString() // 1 วัน
          }
        ]);

      if (downloadError) throw downloadError;

      // สร้างและดาวน์โหลดไฟล์
      const content = keywords;
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${category.title} (100).txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // อัพเดทจำนวนดาวน์โหลดที่เหลือ
      setDownloadsRemaining(prev => prev - 1);

    } catch (error) {
      console.error('Error downloading file:', error);
      alert('เกิดข้อผิดพลาดในการดาวน์โหลด');
    }
  };

  // อัพเดทฟังก์ชัน fetchRandomKeywords
  const fetchRandomKeywords = async (categoryId) => {
    try {
      console.log('Fetching keywords for category:', categoryId);
      
      const { data, error } = await supabase
        .from('keywords')
        .select('keyword')
        .eq('category_id', categoryId);
        
      console.log('Fetched keywords:', { data, error });

      if (error) throw error;

      if (data) {
        const shuffled = data.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 100);
        const keywords = selected.map(item => item.keyword).join(', ');
        setSelectedKeywords(keywords);
      }
    } catch (error) {
      console.error('Error fetching random keywords:', error.message);
      setSelectedKeywords('เกิดข้อผิดพลาดในการดึงข้อมูล');
    }
  };

  // อัพเดทฟังก์ชัน handleConfirm
  const handleConfirm = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setErrorMessage('กรุณาเข้าสู่ระบบ');
        setIsModalOpen(false);
        setIsAlertModalOpen(true);
        return;
      }

      const currentDate = new Date().toISOString().split('T')[0];
      const { data: downloadData } = await supabase
        .from('downloads')
        .select('*')
        .eq('user_id', user.id)
        .eq('download_date', currentDate)
        .maybeSingle();

      const currentCount = downloadData?.count || 0;
      
      if (currentCount >= 10) {
        setErrorMessage('คุณได้ดาวน์โหลดครบ 10 ครั้งต่อวันแล้ว');
        setIsModalOpen(false);
        setIsAlertModalOpen(true);
        return;
      }

      // ดำเนินการดาวน์โหลดและบันทึกข้อมูล
      if (selectedCategory) {
        const { data, error } = await supabase
          .from('keywords')
          .select('keyword')
          .eq('category_id', selectedCategory.id);
          
        if (error) {
          setErrorMessage('เกิดข้อผิดพลาดในการดึงข้อมูล');
          setIsModalOpen(false);
          setIsAlertModalOpen(true);
          return;
        }

        if (data) {
          const shuffled = data.sort(() => 0.5 - Math.random());
          const selected = shuffled.slice(0, 100);
          const keywords = selected.map(item => item.keyword).join('\n');

          // บันทึกประวัติการดาน์โหลด
          if (downloadData) {
            const { error: updateError } = await supabase
              .from('downloads')
              .update({ 
                count: currentCount + 1,
                category_id: selectedCategory.id 
              })
              .eq('user_id', user.id)
              .eq('download_date', currentDate);

            if (updateError) {
              setErrorMessage('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
              setIsModalOpen(false);
              setIsAlertModalOpen(true);
              return;
            }
          } else {
            const { error: insertError } = await supabase
              .from('downloads')
              .insert({
                user_id: user.id,
                download_date: currentDate,
                count: 1,
                category_id: selectedCategory.id,
                expires_at: new Date(Date.now() + 24*60*60*1000).toISOString()
              });

            if (insertError) {
              setErrorMessage('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
              setIsModalOpen(false);
              setIsAlertModalOpen(true);
              return;
            }
          }

          // ส้างและดาวน์โหลดไฟล์
          const blob = new Blob([keywords], { type: 'text/plain' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${selectedCategory.title} (100).txt`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
          // อัพเดทจำนวนดาวน์โหลดที่เหลือ
          setDownloadsRemaining(9 - currentCount);

          // ิดโมดอลยืนยั
          setIsModalOpen(false);

          // เช็คว่าครบจำนวนหรือยัง และแสดงแจ้งเตือน
          if (currentCount + 1 >= 10) {
            setTimeout(() => {
              setErrorMessage('คุณได้ดาวน์โหลดครบ 10 ครั้งต่อวันแล้ว');
              setIsAlertModalOpen(true);
            }, 100); // รอให้โมดอลยืนยันปิดก่อน
          }
        }
      }

    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('เกิดข้อผิดพลาด');
      setIsModalOpen(false);
      setIsAlertModalOpen(true);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Helmet>
        <title>Popular</title>
      </Helmet>
      <main className="flex-grow container mx-auto px-4 py-8">
        {/* หรับความกว้างให้แคบลงอีกด้วย max-w-lg */}
        <div className="mb-12 max-w-lg mx-auto">
          <div className="bg-gradient-to-br from-gray-900 to-black p-6 rounded-lg border border-gray-800">
            <div className="flex items-center justify-between">
              {/* คอลัมน์ซ้าย: แสดงจำนวนดาวน์โหลดที่เหลือ */}
              <div className="flex gap-8">
                <div>
                  <p className="text-3xl font-bold text-purple-400">
                    {downloadsRemaining === null ? '-' : downloadsRemaining}
                  </p>
                  <p className="text-sm text-gray-400">ดาวน์โหลดที่เหลือวันนี้</p>
                </div>
              </div>

              {/* คอลัมน์ขวา: ปั่มสร้าง Prompt */}
              {userSubscription === 'free' ? (
                <Link 
                  to="/vip" 
                  className="inline-flex items-center px-6 py-3 bg-yellow-600 hover:bg-yellow-700 rounded-lg text-white font-medium transition-colors"
                >
                  <span>สมัครสมาชิก VIP</span>
                  <svg 
                    className="w-5 h-5 ml-2" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M13 7l5 5m0 0l-5 5m5-5H6" 
                    />
                  </svg>
                </Link>
              ) : (
                <Link 
                  to="/generator" 
                  className="inline-flex items-center px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg text-white font-medium transition-colors"
                >
                  <span>ไปสร้าง Prompt</span>
                  <svg 
                    className="w-5 h-5 ml-2" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M13 7l5 5m0 0l-5 5m5-5H6" 
                    />
                  </svg>
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* แสดงหมวดหมู่ */}
        <div className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 ${isDownloadDisabled ? 'opacity-30' : ''}`}>
          {categories.map((category) => (
            <div 
              key={category.id} 
              className={`group relative bg-gradient-to-br from-gray-900 to-black rounded-lg overflow-hidden border border-gray-800 
                ${isDownloadDisabled ? 'pointer-events-none' : 'hover:border-purple-500/50'}`}
              onClick={() => handleCardClick(category)}
            >
              {/* รูปภาพ */}
              <div className="aspect-[4/3] relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent z-10" />
                <img
                  src={category.thumbnail}
                  alt={category.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              {/* ข้อมูล */}
              <div className="p-3">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-base font-semibold text-white group-hover:text-purple-400 transition-colors line-clamp-1">
                    {category.title}
                  </h3>
                </div>
                <p className="text-xs text-gray-400 line-clamp-2">
                  {category.description}
                </p>
              </div>

              {/* ปัพเดทปุ่มดูเพิ่มเติม */}
              <div className="p-3 pt-0">
                <button 
                  className="w-full px-3 py-1.5 bg-purple-600/20 hover:bg-purple-600/30 border border-purple-500/30 rounded text-purple-400 text-xs transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardClick(category);
                  }}
                >
                  สุ่ม 100 คำ
                </button>
              </div>

              {/* แสดงข้อความเมื่อปิดการใช้งาน - ย้ายขึ้นมาอยู่บนสุด */}
              {isDownloadDisabled && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/90 z-50">
                  <div className="text-center px-4">
                    {userSubscription === 'free' ? (
                      <>
                        <h2 className="text-2xl md:text-3xl font-bold text-yellow-500 mb-3">
                          สิทธิพิเศษสำหรับสมาชิก VIP
                        </h2>
                        <p className="text-lg md:text-xl text-gray-300">
                          อัพเกรดเป็นสมาชิก VIP เพื่อดาวน์โหลดคีย์เวิร์ด
                        </p>
                      </>
                    ) : (
                      <>
                        <h2 className="text-2xl md:text-3xl font-bold text-red-500 mb-3">
                          คุณได้ใช้จำนวนดาวน์โหลดครบแล้วสำหรับวันนี้
                        </h2>
                        <p className="text-lg md:text-xl text-gray-300">
                          คุณได้ดาวน์โหลดครบ 1,000 คีย์เวิร์ดแล้วในวันนี้
                        </p>
                        <p className="text-sm text-gray-400 mt-2">
                          กรุณากลับมาใหม่ในวันพรุ่งนี้
                        </p>
                      </>
                    )}
                  </div>
                </div>
              )}


            </div>
          ))}
        </div>


      </main>

      {/* เพิ่ม Modal component */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gradient-to-br from-gray-900 to-black p-6 rounded-lg border border-gray-800 max-w-md w-full mx-4">
            <h3 className="text-xl font-bold mb-4">ยืนยันการดาวน์โหลด</h3>
            <p className="text-gray-300 mb-6">
              ตุณต้องการดาวน์โหลด 100 คีย์เวิร์ดจากหมวด "{selectedCategory?.title}" ใช่หรือไม่?
            </p>
            <div className="flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded text-gray-300"
                onClick={() => setIsModalOpen(false)}
              >
                ยกเลิก
              </button>
              <button
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded text-white"
                onClick={handleConfirm}
              >
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  )
}

export default Popular 